import React from 'react'
import { useAuth } from './AuthProvider'
import LoginPage from './LoginPage'
import styled from 'styled-components'

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: white;
  color: black;
  padding: 2rem;
  text-align: center;
`

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #d70036;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`

const DeniedCard = styled.div`
  max-width: 460px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2.5rem;
`

const DeniedTitle = styled.h1`
  color: #d70036;
  font-size: 1.6rem;
  margin-bottom: 1rem;
`

const SignOutButton = styled.button`
  margin-top: 1.5rem;
  background: #d70036;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;

  &:hover { background: #b8002e; }
`

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isAuthorized, isLoading, user, logout } = useAuth()

  if (isLoading) {
    return (
      <CenteredContainer>
        <LoadingSpinner />
        <div>Loading…</div>
      </CenteredContainer>
    )
  }

  if (!isAuthenticated) {
    return <LoginPage />
  }

  // Authenticated with Okta but not a member of any regional access group.
  if (!isAuthorized) {
    return (
      <CenteredContainer>
        <DeniedCard>
          <DeniedTitle>Access Denied</DeniedTitle>
          <p>
            {user?.email ? <strong>{user.email}</strong> : 'Your account'} is not assigned to any
            Barry's International region group. Ask an administrator to add you to the appropriate
            <em> admin-barrys-… </em> or <em> user-barrys-… </em> group.
          </p>
          <SignOutButton onClick={logout}>Sign Out</SignOutButton>
        </DeniedCard>
      </CenteredContainer>
    )
  }

  return <>{children}</>
}

export default ProtectedRoute
